module.exports = __webpack_public_path__ + "media/images/logos/watermark-92f222912b459166d148b6fa3292e83a.svg";